import Head from 'next/head'
import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import Breadcrumbs from '../../../../shared/components/ui/breadcrumbs/Breadcrumbs'
import { PageHeading } from '../../../../shared/components/ui/headings/PageHeading'
import { determineBrowserTabName } from '../../../../shared/themes/logoFunctions'
import { proxyGlobalAuth } from '../../../../shared/proxies/proxyGlobalAuth'
import { DataExportsTable } from './DataExportsTable/DataExportsTable'

export function Container (): ReactElement {
  const { siteTheme: { tableMainColors } } = useSnapshot(proxyGlobalAuth)
  return (
    <>
      <Head>
        <title>Data Exports - {determineBrowserTabName()}</title>
      </Head>

      <Breadcrumbs breadcrumbs={[{ text: 'Data Exports' }]} />
      <PageHeading text="Data Exports" />
      <div className="flex">
        <div className={cn(tableMainColors.classes, 'border-t-4 rounded w-full ')}>
          <DataExportsTable />
        </div>
      </div>
      <div />

    </>
  )
}
